import React, { useState, useEffect } from 'react';
import ThemeToggle from './ThemeToggle';
import { personalInfo } from '../data/portfolio';
import './Header.css';

interface HeaderProps {
  activeSection: string;
}

const Header: React.FC<HeaderProps> = ({ activeSection }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navItems = [
    { id: 'hero', label: 'Accueil' },
    { id: 'mission', label: 'Actualité' },
    { id: 'skills', label: 'Compétences' },
    { id: 'projects', label: 'Portfolio' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <div className="logo" onClick={scrollToTop}>
            <svg
              className="logo-mark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 160 160"
              fill="none"
              aria-label="Logo Cyrille Tual"
              role="img"
            >
              <g transform="translate(80 80)">
                <ellipse rx="68" ry="26" stroke="currentColor" strokeWidth="5" fill="none" transform="rotate(0)" />
                <ellipse rx="68" ry="26" stroke="currentColor" strokeWidth="5" fill="none" transform="rotate(60)" />
                <ellipse rx="68" ry="26" stroke="currentColor" strokeWidth="5" fill="none" transform="rotate(120)" />
                <circle r="26" fill="#1E63F5" />
                <text y="9" textAnchor="middle" fontFamily="Inter, system-ui, sans-serif" fontWeight="800" fontSize="26" letterSpacing="-1" fill="#fbf9f5">CT</text>
              </g>
            </svg>
            <span className="logo-highlight">Cyrille</span> Tual
          </div>

          <nav className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}>
            {navItems.map((item) => (
              <button
                key={item.id}
                className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                onClick={() => scrollToSection(item.id)}
              >
                {item.label}
              </button>
            ))}
            <a
              href={personalInfo.cvUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary cv-btn"
            >
              CV
            </a>
            <ThemeToggle />
          </nav>

          <div className="mobile-controls">
            <ThemeToggle />
            <button
              className="mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle mobile menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;